import classNames from "classnames";
import React from "react";

type Props = {
  children: React.ReactNode;
  textClass?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = ({
  children,
  className,
  textClass = "text-14-semi-bold",
  ...props
}: Props) => {
  return (
    <button
      className={classNames("bg-[#262626] px-[16px] disabled:bg-[#A3A3A3] disabled:bg-opacity-10", className)}
      {...props}
    >
      <span className={classNames("text-white whitespace-pre", textClass, props.disabled ? "!text-[#A3A3A3]" : "")}>
        {children}
      </span>
    </button>
  );
};
